import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-chart-page',
    templateUrl: './showroom-exhibit-chart-page.component.html',
    styleUrls: ['./showroom-exhibit-chart-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitChartPageComponent {

}
